var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBank = props => /*#__PURE__*/React.createElement("svg", _extends({
  height: "100px",
  width: "100px",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  fill: "none",
  x: "0px",
  y: "0px"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M3.78885 7.10546L11.5528 3.22349C11.8343 3.08273 12.1657 3.08273 12.4472 3.22349L20.2111 7.10546C21.155 7.57737 20.8192 8.99989 19.7639 8.99989H4.23607C3.18084 8.99989 2.84503 7.57737 3.78885 7.10546Z",
  fill: "black"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M6 18.9999L6 10.9999H8L8 18.9999H11V10.9999H13L13 18.9999H16V10.9999H18L18 18.9999H20C20.5523 18.9999 21 19.4476 21 19.9999C21 20.5522 20.5523 20.9999 20 20.9999H4C3.44772 20.9999 3 20.5522 3 19.9999C3 19.4476 3.44772 18.9999 4 18.9999H6Z",
  fill: "black"
})));
export default SvgBank;